import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import FreeHtml from 'apps/scribe/FreeHtml';

export default class PostcodeBanner extends Component {
  static propTypes = {
    clearPostcodeBanner: PropTypes.func.isRequired,
    bannerId: PropTypes.number, // Banner ID - FreeHTML parent document ID (docNo)
    bannerVersion: PropTypes.number, // Banner version - FreeHTML parent document version ID (docVersionNo)
    ensurePostcodeBanner: PropTypes.func.isRequired,
    html: PropTypes.string,
    isLoggedIn: PropTypes.bool.isRequired,
    isHidden: PropTypes.bool,
    sendClosedPostcodeBannerNotification: PropTypes.func.isRequired,
  };

  state = {
    shouldDisplay: true,
  };

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.props.isLoggedIn !== nextProps.isLoggedIn
      || this.props.bannerVersion !== nextProps.bannerVersion
      || this.props.isHidden !== nextProps.isHidden
      || (this.props.isLoggedIn && this.state.shouldDisplay !== nextState.shouldDisplay)
    );
  }

  componentDidUpdate(prevProps) {
    const { clearPostcodeBanner, ensurePostcodeBanner, isLoggedIn } = this.props;
    if (prevProps.isLoggedIn === isLoggedIn) {
      // No changes in logged in status
      return;
    }

    if (isLoggedIn) {
      ensurePostcodeBanner();
    } else if (prevProps.isLoggedIn) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ shouldDisplay: true }); // Reset state on customer log out
      clearPostcodeBanner();
    }
  }

  closeBanner = () => {
    const { bannerId, bannerVersion } = this.props;
    this.setState({ shouldDisplay: false });
    this.props.sendClosedPostcodeBannerNotification(bannerId, bannerVersion);
  };

  render() {
    const { bannerId, html, isHidden, isLoggedIn } = this.props;
    const { shouldDisplay } = this.state;

    if (!isLoggedIn || !bannerId || !html || isHidden) {
      return null;
    }

    return (
      <div className={classNames('hd-postcodeBanner', { 'hd-postcodeBanner--hidden': !shouldDisplay })}>
        <div className="hd-postcodeBanner__content">
          <FreeHtml html={html} />
        </div>
        {shouldDisplay && (
          <div className="hd-postcodeBanner__buttonWrapper">
            <button
              className="hd-postcodeBanner__closeButton"
              type="button"
              title="Close"
              aria-label="Close"
              onClick={this.closeBanner}
            />
          </div>
        )}
      </div>
    );
  }
}
